module.exports = __webpack_public_path__ + "img/1-small.f4b06a2f.png";